import produce from "immer";
import * as actions from "./actions";

let initialState = {
  borrowerTerms: {
    fetching: false,
    fetched: false,
    data: {},
  },

  generalTermsSL: {
    fetching: false,
    fetched: false,
    data: {},
  },

  generalTermsLS: {
    fetching: false,
    fetched: false,
    data: {},
  },

  lenderTerms: {
    fetching: false,
    fetched: false,
    data: {},
  },

  paymentServiceTerms: {
    fetching: false,
    fetched: false,
    data: {},
  },
};

const terms = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      //Borrower terms
      case actions.BORROWER_TERMS_GET_SUCCESS:
        draft.borrowerTerms.fetching = false;
        draft.borrowerTerms.fetched = true;
        draft.borrowerTerms.data = action.response;
        break;
      case actions.BORROWER_TERMS_GET_REQUEST:
        draft.borrowerTerms.fetching = true;
        break;
      //Lender terms
      case actions.LENDER_TERMS_GET_SUCCESS:
        draft.lenderTerms.fetching = false;
        draft.lenderTerms.fetched = true;
        draft.lenderTerms.data = action.response;
        break;
      case actions.LENDER_TERMS_GET_REQUEST:
        draft.lenderTerms.fetching = true;
        break;
      //Loanstep general terms
      case actions.LOANSTEP_GENERAL_TERMS_GET_SUCCESS:
        draft.generalTermsLS.fetching = false;
        draft.generalTermsLS.fetched = true;
        draft.generalTermsLS.data = action.response;
        break;
      case actions.LOANSTEP_GENERAL_TERMS_GET_REQUEST:
        draft.generalTermsLS.fetching = true;
        break;
      case actions.LOANSTEP_GENERAL_TERMS_SEND_ERROR:
        draft.generalTermsLS.error = action.error;
        break;
      //Savelend general terms
      case actions.SAVELEND_GENERAL_TERMS_GET_SUCCESS:
        draft.generalTermsSL.fetching = false;
        draft.generalTermsSL.fetched = true;
        draft.generalTermsSL.data = action.response;
        break;
      case actions.SAVELEND_GENERAL_TERMS_GET_REQUEST:
        draft.generalTermsSL.fetching = true;
        break;
      case actions.SAVELEND_GENERAL_TERMS_GET_ERROR:
        draft.generalTermsSL.error = action.error;
        break;
      //Payment terms
      case actions.PAYMENT_SERVICE_TERMS_GET_SUCCESS:
        draft.paymentServiceTerms.fetching = false;
        draft.paymentServiceTerms.fetched = true;
        draft.paymentServiceTerms.data = action.response;
        break;
      case actions.PAYMENT_SERVICE_TERMS_GET_REQUEST:
        draft.paymentServiceTerms.fetching = true;
        break;
      default:
        return draft;
    }
  });
};

export default terms;
